<script setup lang="ts">
import { NewProduct } from '@/types/api/api-v4/product'
import {
  ProductParentType,
  ProductTagSize,
} from '@/types/components/product-card.types'

import ProductTag from '@/components/Product/ProductTags/ProductTag.vue'

const MIN_RATING = 4.8

type Props = {
  product: NewProduct
  type: ProductParentType
  size?: ProductTagSize
}

const props = defineProps<Props>()

const componentClasses = [
  'product-tag-rating',
  `product-tag-rating--type-${props.type}`,
]

const isVisible = computed(() => {
  return props.product?.rating && props.product?.rating >= MIN_RATING
})
</script>

<template>
  <product-tag
    v-if="isVisible"
    :class="componentClasses"
    color="var(--ui-white)"
    background-color="rgba(var(--ui-secondary-rgb), 0.8)"
    :type="type"
    :size="size"
  >
    <nuxt-img src="/product/rating-star.svg" alt="Рейтинг" />

    <span>{{ product.rating }}</span>
  </product-tag>
</template>

<style lang="scss" scoped>
.product-tag-rating {
  img {
    flex-shrink: 0;
  }
}

.product-tag-rating--type-card {
  img {
    width: 10px;
    height: 10px;

    @include media('>=desktop-mini') {
      width: 14px;
      height: 14px;
    }
  }
}

.product-tag-rating--type-detail {
  img {
    width: 16px;
    height: 16px;
  }
}
</style>
